<template>
    <section>
    <!-- PC -->
    <b-card v-if="window.width > 1023" class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row style="margin-top: 0px;">
        <b-col xl="2" md="2" sm="2">
          <div
            class="main-menu"
            style="font-family: 'NanumBarunGothic';"
          >
            <!-- main menu header-->
            <div class="d-flex align-items-center" style="height: 10%; margin-top: 4%;">
              <slot
                name="header"
              >
                <ul>
                  <!-- Logo & Text -->
                  <li>
                    <span>
                      <b-img :src="voteLogoImage" alt="logo" style="width: 60%; margin-left: 2rem; margin-top: 0.8rem;"/>
                    </span>
                  </li>
                </ul>
              </slot>
            </div>
            <!-- / main menu header-->
          </div>
        </b-col>
        


        <b-col xl="6" md="6" sm="6" style="margin-left: 5rem;">
          <div id="voteMenu" style="margin-left: 0rem;">
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="trend"
              size=""
              button
              @change="voteMenuClick('trend')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              점유율 분석
            </b-form-radio>
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="relation"
              size=""
              button
              @change="voteMenuClick('relation')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              연관어 분석
            </b-form-radio>
          </div>
        </b-col>



        <b-col xl="1" md="1" sm="1" style="margin-left: -15rem;">
          <b-row class="d-flex align-items-center justify-content-center">
            <span class="bg-secondary round text-white ml-2 mt-1" style="background-color: #404040 !important; width: 100%; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1" class="d-flex align-items-start" style="margin-top: -3px;">
          <b-row class="d-flex align-items-center justify-content-start">
            <vue-select
              class="first-class"
              label="title"            
              :options="weekList"
              :clearable="true"
              v-model="selectedWeek"
              placeholder="주별(전체)"
              style="height: 32px; width: 250px; text-align: center; font-size: 14px; margin-left: 5px;"
            >
            </vue-select>
          </b-row>
        </b-col>

        <b-col xl="2" md="2" sm="2" style="margin-left: 9rem;">
          <div
            class="main-menu"
            style="font-family: 'NanumBarunGothic';"
          >
            <!-- main menu header-->
            <div class="d-flex align-items-center" style="height: 10%; margin-top: 4%;">
              <slot
                name="header"
              >
                <ul>
                  <!-- Logo & Text -->
                  <li>
                    <span>
                      <b-img :src="uptrenixLogoImage" alt="logo" style="width: 60%; margin-left: 6rem; margin-top: 0.3rem;"/>
                    </span>
                  </li>
                </ul>
              </slot>
            </div>
            <!-- / main menu header-->
          </div>
        </b-col>

      </b-row>
    </b-card>

    <!-- Pad -->
    <b-card v-if="window.width > 767 && window.width <= 1023" class="mb-1 sticky-top" style="height: 120px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row style="margin-top: 0px;">
        <b-col>
          <ul>
            <b-img :src="voteLogoImage" alt="logo" style="width: 80%; margin-top: 0.4rem;"/>
          </ul>
        </b-col>
        <b-col>
          <div id="voteMenu" style="margin-left: 0rem;" class="d-flex justify-content-center">
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="trend"
              size=""
              button
              @change="voteMenuClick('trend')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              점유율 분석
            </b-form-radio>
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="relation"
              size=""
              button
              @change="voteMenuClick('relation')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              연관어 분석
            </b-form-radio>
          </div>
        </b-col>
        <b-col>
          <ul>
            <b-img :src="uptrenixLogoImage" alt="logo" style="width: 80%;"/>
          </ul>
        </b-col>
      </b-row>
      <b-row style="margin-top: 0.5rem;" class="d-flex justify-content-center">
        <b-col>
            <vue-select
              class="first-class"
              label="title"            
              :options="weekList"
              :clearable="true"
              v-model="selectedWeek"
              placeholder="주별(전체)"
              style="text-align: center; font-size: 14px;"
            >
            </vue-select>
        </b-col>
      </b-row>
    </b-card>

    <!-- 모바일 -->
    <b-card v-if="window.width <= 767" class="mb-1 sticky-top" style="height: 150px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col>
          <ul>
            <b-img :src="voteLogoImage" alt="logo" style="width: 80%; margin-top: 0.4rem;"/>
          </ul>
        </b-col>
        <b-col>
          <ul>
            <b-img :src="uptrenixLogoImage" alt="logo" style="width: 80%;"/>
          </ul>
        </b-col>
      </b-row>
      <b-row style="margin-top: 0px;">
        <b-col>
          <div id="voteMenu" style="margin-left: 0rem;" class="d-flex justify-content-center">
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="trend"
              size=""
              button
              @change="voteMenuClick('trend')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              점유율 분석
            </b-form-radio>
            <b-form-radio
              class="btn-radio"
              v-model="selectedVoteMenu"
              value="relation"
              size=""
              button
              @change="voteMenuClick('relation')"
              style="display: inline-block !important; margin-right: 1rem; min-width: 10rem;"
            >
              연관어 분석
            </b-form-radio>
          </div>
        </b-col>
      </b-row>
      <b-row style="margin-top: 0.5rem;" class="d-flex justify-content-center">
        <b-col>
            <vue-select
              class="first-class"
              label="title"            
              :options="weekList"
              :clearable="true"
              v-model="selectedWeek"
              placeholder="주별(전체)"
              style="text-align: center; font-size: 14px;"
            >
            </vue-select>
        </b-col>
      </b-row>
    </b-card>

    <!-- PC -->
    <b-card v-if="window.width > 767" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col style="display: inline-flex; justify-content: center;">
          <vue-select
              class="first-class"
              label="title"            
              :options="typeList"
              :clearable="false"
              v-model="selectedType"
              placeholder="후보별"
              style="width: 8rem; text-align: center; font-size: 14px; margin-left: 0px; min-width: 8rem;"
            >
          </vue-select>
          <div id="candidateMenu" style="margin-left: 2rem; padding-bottom: 0rem;">
            <b-form-group>
              <b-form-radio-group
                id="candidateMenuGroup"
                v-model="selectedCandidate"
                :options="candidateList"
                name="radios-btn-default"
                buttons
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>

    </b-card>

    <!-- 모바일 -->
    <b-card v-if="window.width <= 767" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col style="text-align:center;">
          <vue-select
              class="first-class"
              label="title"            
              :options="typeList"
              :clearable="false"
              v-model="selectedType"
              placeholder="후보별"
              style="width: 8rem; text-align: center; font-size: 14px; margin-left: 5px;"
            >
          </vue-select>
        </b-col>
      </b-row>
      <b-row style="margin-top: 10px;">
        <b-col style="text-align:center;">
          <div id="candidateMenu" style="margin-left: 0rem; padding-bottom: 1rem;">
            <b-form-group>
              <b-form-radio-group
                id="candidateMenuGroup"
                v-model="selectedCandidate"
                :options="candidateList"
                name="radios-btn-default"
                buttons
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-card>
    
    <!-- PC -->
    <b-card v-if="window.width > 767" ref="comPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col style="text-align:center;">
          <h1>검색 연관어</h1>
        </b-col>
      </b-row>
      <b-row style="margin-top: 5px;">
        <b-col xl="1" md="1" sm="1"></b-col>
        <b-col id="competitionBarCol" xl="6" md="6" sm="6">
          <b-row>
            <b-col>
              <vote-relation-chart-net
              :netChartNodes="netChartNodes"
              :netChartLinks="netChartLinks"
              :windowWidth="windowWidth"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col id="competitionDonutCol" xl="4" md="4" sm="4">
          <b-row>
            <b-col>
              <b-table
                class="comTable position-relative mr-1 h-120"
                ref="refVoteTable"
                :items="fetchGroups"
                :fields="tableColumns"
                :sort-desc.sync="sortDesc" 
                :sort-by.sync="sortBy"
                :sort-direction='sortDirection'
                :busy="isBusy"
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 546px;"
                selectable
                select-mode="single"
                @row-selected="onRowSelected"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy !== key" src="/caretupdown.png" style="width: 10px;"></b-img>
                    <b-img v-else-if="sortDesc" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1"></b-col>
      </b-row>
    </b-card>
    

    <!-- 모바일 -->
    <b-card v-if="window.width <= 767" ref="comPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col style="text-align:center;">
          <h1>검색 연관어</h1>
        </b-col>
      </b-row>
      <b-row style="margin-top: 5px;">
        <b-col id="competitionBarCol">
          <b-row>
            <b-col>
              <vote-relation-chart-net
              :netChartNodes="netChartNodes"
              :netChartLinks="netChartLinks"
              :windowWidth="windowWidth"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="margin-top: 5px;">
        <b-col id="competitionDonutCol">
          <b-row>
            <b-col>
              <b-table
                class="comTable position-relative mr-1 h-120"
                ref="refVoteTable"
                :items="fetchGroups"
                :fields="tableColumns"
                :sort-desc.sync="sortDesc" 
                :sort-by.sync="sortBy"
                :sort-direction='sortDirection'
                :busy="isBusy"
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 546px;"
                selectable
                select-mode="single"
                @row-selected="onRowSelected"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy !== key" src="/caretupdown.png" style="width: 10px;"></b-img>
                    <b-img v-else-if="sortDesc" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card ref="comPrintArea2" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 10px;">
        <b-col cols="12" style="text-align:center;">
          <h1>검색어 트랜드</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center; color: #ea5455; margin-bottom: 0rem;">
            📢 아래 범례를 선택하면 그래프에 해당 범례의 데이터가 숨김/표시 됩니다.
          </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <vote-chart-line
            :voteChartLine="voteChartLineSeries(lineChartData)"
            :lineChartCategories="lineChartCategories"
            :lineChartDesc="lineChartDesc"
            :isChartInit="lnChartInit"
            id="competitionChartLine"
          />
        </b-col>
      </b-row>
    </b-card>

    </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,
} from "bootstrap-vue";





import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";




import VoteChartLine from "@/views/vote2025/components/VoteChartLine.vue";

import VoteRelationChartNet from "@/views/vote2025/components/VoteRelationChartNet.vue";


import CisVoteService from "@/services/cis-vote.service";
import CategoryService from "@/services/category.service";

import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";

import axios from "axios"

const cancelToken = axios.CancelToken;
var source = cancelToken.source();


var sel_category = 9999;

export default {
  name: "voteTrend",
  components: {
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,
    BFormRadio,
    BFormRadioGroup,

    
    VoteChartLine,
    VoteRelationChartNet,
  },
  data() {
    return {

      window: { width: 0, height: 0 },

      weekList : [
        {'title' : 'TOTAL (3/30~)', 'id': 'total'}
        ,{'title' : '4월 1주차 (3/31~4/6)', 'id': '41'}
        ,{'title' : '4월 2주차 (4/7~4/13)', 'id': '42'}
        ,{'title' : '4월 3주차 (4/14~4/20)', 'id': '43'}
        ,{'title' : '4월 4주차 (4/21~4/27)', 'id': '44'}
        ,{'title' : '5월 1주차 (4/28~5/4)', 'id': '51'}
        ,{'title' : '5월 2주차 (5/5~5/11)', 'id': '52'}
        ,{'title' : '5월 3주차 (5/12~5/18)', 'id': '53'}
        ,{'title' : '5월 4주차 (5/19~5/25)', 'id': '54'}
        ,{'title' : '5월 5주차 (5/26~6/01)', 'id': '55'}
        ,{'title' : '6월 1주차 (6/02~6/03)', 'id': '61'}
      ],

      typeList:[
        {'title' : '후보별', 'id': 'c'},
        {'title' : '정당별', 'id': 'p'}
      ],

      selectedWeek: {'title' : 'TOTAL (3/30~)', 'id': 'total'},
      selectedType: {'title' : '후보별', 'id': 'c'},

      selectedVoteMenu: "relation",

      candidateList: [],
      selectedCandidate: '이재명',

      netChartNodes: [], 
      netChartLinks: [],

      windowWidth: 0,
      windowHeight: 0,

      tableColumns: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-center', tdClass: 'text-center'},
        { key: 'keyword', label: '키워드', sortable: true , thClass: 'text-center' },
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-center', tdClass: 'text-right'},
      ],

      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',

      fetchGroups: null,

      isBusy: false,


      lineChartCategories: [],
      lineChartData: [],
      lineChartDesc: [],

      lnChartInit: false,













      selectedBrandList: [],


      
      

      totalFreq: 0,
      
      height: 0,

      
      selectedOptions: [],

      


      

    };
  },
  computed: {
    check_voteMenu() {
      return this.$store.getters.getSelectedVoteMenu
    },
  },
  watch: {
    sortDesc(val) {
      if(val)
        this.sortBy = null
    },
    selectedCandidate(){
      this.candidateClick()
    },
    check_voteMenu(value) {
      this.selectedVoteMenu = value
    },
    selectedWeek(){
      console.log('--- change selectedWeek ---')
      console.log(this.selectedWeek)
      if(this.selectedWeek){
        console.log(this.selectedWeek.id)        
      }else{
        this.selectedWeek = this.weekList[0]
      }
      this.loadDataNet()
      this.loadDataLine()
    },
    selectedType(){
      this.setCandidateList()
    }
    
    
  },
  methods: {

    async onRowSelected(item){
      console.log('onRowSelected')
      if(item.length > 0){
        var queryKeyword = item[0].keyword
        var naverUrl = 'https://search.naver.com/search.naver?query='+queryKeyword
        // 새 창 열기
        window.open(naverUrl, '_blank');
      }
    },

    handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
    },

    async setCandidateList(){
      console.log('-- setCandidateList --')
      this.candidateList = []
      var startDate = '2025-03-30';
      var endDate = this.getYesterday().toISOString().split('T')[0];
      var typeGubun = 'c'
      if (this.selectedType){
        typeGubun = this.selectedType.id
      }
      const response = await CisVoteService.getCandidateList({
        startDate : startDate,
        endDate : endDate,
        typeGubun : typeGubun
      }, source);

      if (response && response.status === 200) {
        console.log('-- getCandidateList --')
        for(let i = 0; i < response.data.data.length; i++){
          if(i ==0){
            this.selectedCandidate = response.data.data[i].candidate
          }
          this.candidateList.push(response.data.data[i].candidate)
        }
        this.loadDataNet();
        this.loadDataLine();
      }
    },
    checkWindowSize(){
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      console.log('windowHeight : ', this.windowHeight)
      console.log('windowWidth : ', this.windowWidth)
    },


    candidateClick(){
      console.log('-- candidateClick --')
      console.log(this.selectedCandidate)
      this.loadDataNet();
      this.loadDataLine();
    },

    voteMenuClick(mode) {      
      this.$store.dispatch('callVoteMenu', { voteMenu: mode })

      switch(mode) {
        case 'trend':
          this.$router.push({ name: "vote2025t" }).catch(() => {});
          break;
        case 'emotion':
          this.$router.push({ name: "vote2025e" }).catch(() => {});
          break;
        case 'relation':
          this.$router.push({ name: "vote2025r" }).catch(() => {});
          break;
      }
    },
    
    matchColName(propNm) {
      return colNameDict[propNm]
    },

    removeNullString(arrString) {
      var ret = [];

      for (const str of arrString) {
        if(str.length > 0) {
            ret.push(str);
        }
      }

      return ret;
    },

    async loadDataNet(){
      console.log("---------- loadDataNet ----------");

      var week = 'total'
      if (this.selectedWeek){
        week = this.selectedWeek.id
      }

      console.log('week : ', week)
      var startDate = ''
      var endDate = ''

      switch(week){
        case 'total': 
                startDate = '2025-03-30';
                endDate = '2025-06-03';
                break;
        case '41': 
                startDate = '2025-03-31';
                endDate = '2025-04-06';
                break;
        case '42': 
                startDate = '2025-04-07';
                endDate = '2025-04-13';
                break;
        case '43': 
                startDate = '2025-04-14';
                endDate = '2025-04-20';
                break;
        case '44': 
                startDate = '2025-04-21';
                endDate = '2025-04-27';
                break;
        case '51': 
                startDate = '2025-04-28';
                endDate = '2025-05-04';
                break;
        case '52': 
                startDate = '2025-05-05';
                endDate = '2025-05-11';
                break;
        case '53': 
                startDate = '2025-05-12';
                endDate = '2025-05-18';
                break;
        case '54': 
                startDate = '2025-05-19';
                endDate = '2025-05-25';
                break;
        case '55': 
                startDate = '2025-05-26';
                endDate = '2025-06-01';
                break;
        case '61': 
                startDate = '2025-06-02';
                endDate = '2025-06-03';
                break;
        default: 
                startDate = '2025-03-31';
                endDate = '2025-06-03';
      }

      console.log('startDate : ', startDate)
      console.log('endDate : ', endDate)
      
      var typeGubun = 'c'
      if (this.selectedType){
        typeGubun = this.selectedType.id
      }
      console.log('typeGubun : ', typeGubun)

      const response = await CisVoteService.getVoteDataNet({
        startDate : startDate,
        endDate : endDate,
        candidate : this.selectedCandidate,
        typeGubun : typeGubun
      }, source);



      if (response && response.status === 200) {
        console.log('-- getVoteDataNet --')
        console.log(response)

        var sub_brand_total = response.data.data[0].subTotal
        var candidate = response.data.data[0].sub

        this.netChartNodes = []
        this.netChartLinks = []
        this.netChartNodes.push({ id: '['+candidate+']', group: 2, freq: sub_brand_total })
        var sub_brand_cnt2 = 0
        
        for(const item of response.data.data) {
          sub_brand_cnt2 += 1
          if(sub_brand_cnt2 <= 15){
            this.netChartNodes.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'sub_brand', rank: sub_brand_cnt2, negative: item.negative})
            this.netChartLinks.push({ source: '['+candidate+']', target: item.keyword })
          }
        }


        this.isBusy = false
        this.fetchGroups = null
        this.fetchGroups = response.data.data
      
      }


    },


    
    async loadDataLine(){
      console.log('---------- loadDataLine ----------')
      var week = 'total'
      if (this.selectedWeek){
        week = this.selectedWeek.id
      }
      var startDate = ''
      var endDate = ''

      switch(week){
        case 'total': 
                startDate = '2025-03-30';
                endDate = '2025-06-03';
                break;
        case '41': 
                startDate = '2025-03-31';
                endDate = '2025-04-06';
                break;
        case '42': 
                startDate = '2025-04-07';
                endDate = '2025-04-13';
                break;
        case '43': 
                startDate = '2025-04-14';
                endDate = '2025-04-20';
                break;
        case '44': 
                startDate = '2025-04-21';
                endDate = '2025-04-27';
                break;
        case '51': 
                startDate = '2025-04-28';
                endDate = '2025-05-04';
                break;
        case '52': 
                startDate = '2025-05-05';
                endDate = '2025-05-11';
                break;
        case '53': 
                startDate = '2025-05-12';
                endDate = '2025-05-18';
                break;
        case '54': 
                startDate = '2025-05-19';
                endDate = '2025-05-25';
                break;
        case '55': 
                startDate = '2025-05-26';
                endDate = '2025-06-01';
                break;
        case '61': 
                startDate = '2025-06-02';
                endDate = '2025-06-03';
                break;
        default: 
                startDate = '2025-03-31';
                endDate = '2025-06-03';
      }

      console.log('startDate : ', startDate)
      console.log('endDate : ', endDate)

      var typeGubun = 'c'
      if (this.selectedType){
        typeGubun = this.selectedType.id
      }
      console.log('typeGubun : ', typeGubun)

      var candidate = '이재명'
      candidate = this.selectedCandidate

      this.lnChartInit = false;

      this.lineChartData = []
      this.lineChartCategories = []
      this.lineChartDesc = []

      
      const response = await CisVoteService.getVoteRelationDataLine({
        startDate : startDate,
        endDate : endDate,
        typeGubun : typeGubun,
        candidate : candidate
      }, source);

      if (response && response.status === 200) {
        console.log('-- getVoteRelationDataLine --')
        console.log(response)

        this.lnChartInit = true;
        this.lineChartData = []
        this.lineChartCategories = []
        this.lineChartDesc = []

        for(const item of response.data.data) {
            this.lineChartData.push({
                item: item.item,
                type: 'line',
                data: item.rate.split(','),
                description: item.freq.split(','),
                hidden: item.rank < 2 ? true : false
            })

            if (this.lineChartCategories.length == 0) 
                this.lineChartCategories = item.date.split(',')
            
            this.lineChartDesc.push(item.freq.split(','))
        }
        
        // this.top_rank_brands = this.lineChartData[0].brand;
        // this.top_rank_brand_rate_diff = this.lineChartData[0].data[this.lineChartCategories.length - 1] - this.lineChartData[0].data[0];
      }
      
    },


    voteChartLineSeries(cd) {
        const chartSeries = [];

        for (const item of cd){
          chartSeries.push({ name: item.item, type: item.type, data: item.data, hidden: item.hidden })
        }

        return chartSeries;
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    getYesterday(){
      let d = new Date();
      d.setDate(d.getDate() -1);
      return d;
    },

    
    removeSelItem(target, sel_idx) {
      target.splice(sel_idx, 1)
      target = [...target]
    },

    abort(isReset, message) {
      console.log('---------- abort ---------- // ' + message)

      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },
  },

  mounted(){
    console.log('---------- mounted ----------')

  },

  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },

  destroyed() {
    console.log('---------- destroyed ----------')

  },

  setup(props) {
    // App Name
    const { appName, appLogoImage, voteLogoImage, uptrenixLogoImage } = $themeConfig.app;
    return {
      // App Name
      appName,
      appLogoImage,
      voteLogoImage, 
      uptrenixLogoImage,
    };
  },

  async created() {
    console.log('---------- create ----------')

    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    this.lineChartData = [];
    this.lineChartCategories = [] 

    this.checkWindowSize();
    this.setCandidateList();
  },
};

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#competitionDonutCol .apexcharts-canvas .apexcharts-text, 
#competitionDonutCol .apexcharts-canvas .apexcharts-tooltip-text, 
#competitionDonutCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionDonutCol .apexcharts-canvas .apexcharts-datalabel, 
#competitionBarCol .apexcharts-canvas .apexcharts-text, 
#competitionBarCol .apexcharts-canvas .apexcharts-tooltip-text, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel 
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}

#competitionBarCol .apexcharts-canvas .apexcharts-datalabel-label, 
#competitionBarCol .apexcharts-canvas .apexcharts-datalabel
{
  margin-left: 5rem;
}

#competitionBarCol .graphic-container {
  min-height: 480px;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
}

.first-class .vs__dropdown-menu,
.first-attribute .vs__dropdown-menu,
.second-attribute .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.mb-1 .sticky-top{
  align-self: flex-start;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

/* Hide default icon */
.comTable .table.b-table > thead > tr > th,
.comTable .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
}

.select-brand .v-label {
  font-size: 14px;
}

.select-brand .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 6px 0;
}

.comselectitemlist .v-list-item {
  min-height: 28px;
}

.comselectitemlist .v-list-item__content {
  padding: 5px 0;
}

.comselectitemlist .v-list-item__action {
  margin: 5px 0;
}


#voteMenu .btn-radio .btn-secondary {
  background-color: #AFAFAF !important;
  border-color: #AFAFAF !important;
  // background-color: #4E86FF !important;
  // border-color: #4E86FF !important;
  box-shadow: none;
  width: 10rem;
}

#voteMenu .btn-radio .btn-secondary.active {
  background-color: #404040 !important;
  border-color: #404040 !important;
  // background-color: #1951dc !important;
  // border-color: #1c5cff !important;
}

#candidateMenuGroup {
  display: block;
}

#candidateMenuGroup > label.btn.btn-secondary {
  background-color: #AFAFAF !important;
  border-color: #ffffff !important;
  // background-color: #4E86FF !important;
  // border-color: #4E86FF !important;
  box-shadow: none;
  width: 8rem;
  font-size: 1rem;
  padding: 0.5rem 0.8rem;
  margin-top: 0.2rem;
}

#candidateMenuGroup > label.btn.btn-secondary.active {
  background-color: #404040 !important;
  border-color: #ffffff !important;
  // background-color: #1951dc !important;
  // border-color: #1c5cff !important;
}

#candidateMenuGroup_m > label.btn.btn-secondary {
  background-color: #AFAFAF !important;
  border-color: #ffffff !important;
  // background-color: #4E86FF !important;
  // border-color: #4E86FF !important;
  box-shadow: none;
  width: 20rem;
  font-size: 1rem;
  padding: 0.5rem 0.8rem;
  margin-top: 0.1rem;
}

#candidateMenuGroup_m > label.btn.btn-secondary.active {
  background-color: #404040 !important;
  border-color: #ffffff !important;
  // background-color: #1951dc !important;
  // border-color: #1c5cff !important;
}

</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
